import Column from '@components/column'
import WithdrawBanner from '../cards/withdrawBanner'
import Info from './info'
const Transactions = () => {
  return (
    <Column rowGap={20}>
      <WithdrawBanner />
      <Info />
    </Column>
  )
}

export default Transactions
